import { useState } from 'react';
import { SolutionDisplay, FrameContent } from '../PrologComponents';
import { SettingsRow, Toggle } from './SettingsPopup';

// ── Icon components ──────────────────────────────────────────────────────────

function GearIcon() {
    return (
        <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true">
            <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
            <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.892 3.433-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.892-1.64-.901-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.474l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>
        </svg>
    );
}

function HelpIcon() {
    return (
        <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true">
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
            <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"/>
        </svg>
    );
}

function GitHubIcon() {
    return (
        <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true">
            <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
        </svg>
    );
}

// ── Main component ───────────────────────────────────────────────────────────

// Side-drawer info panel — tab strip on the LEFT, results body on the RIGHT.
// Settings are accessed via the ⚙ icon in the toolbar (floating popup).
export function InfoPanel({
    display, solutionSnaps, offset, onOffsetChange,
    namedVars, idVec, varIdVec,
    inactiveFrames, setInactiveFrames,
    showBindings, setShowBindings,
    showStack, setShowStack,
    showDecisionStack, setShowDecisionStack,
    showInternalErrors, setShowInternalErrors,
    tailCallOpt, setTailCallOpt,
    lightMode, setLightMode,
    sidebarRef,
    activeChain, choicePointMap,
}) {
    const [open,             setOpen]             = useState(true);
    const [settingsOpen,     setSettingsOpen]     = useState(false);
    const [helpOpen,         setHelpOpen]         = useState(false);
    const [solutionExpanded, setSolutionExpanded] = useState(false);
    const [hoveredIdx,         setHoveredIdx]         = useState(null);
    const [hoveredDecisionIdx, setHoveredDecisionIdx] = useState(null);

    // ── Solution nav ─────────────────────────────────────────────────────────
    const count = solutionSnaps?.length ?? 0;
    const eff   = count > 0 ? Math.min(offset, count - 1) : 0;
    const solution = count > 0 ? solutionSnaps[count - 1 - eff] : null;
    const pos   = count > 0 ? count - eff : 0;

    const solutionNav = count > 0 && (
        <div className="solution-nav solution-nav-compact">
            <button
                className="solution-nav-btn"
                onClick={() => onOffsetChange(eff + 1)}
                disabled={pos <= 1}
                title="Older solution"
            >◀</button>
            <span className="solution-nav-count">{pos}/{count}</span>
            <button
                className="solution-nav-btn"
                onClick={() => onOffsetChange(eff - 1)}
                disabled={pos >= count}
                title="Newer solution"
            >▶</button>
        </div>
    );

    const solutionContent = (
        display?.atEnd && !solution
            ? <pre className="solution-box solution-box-failure">false.</pre>
            : solution
                ? <SolutionDisplay
                      termVec={solution.termVec}
                      namedVars={namedVars}
                      idVec={idVec}
                      varIdVec={varIdVec}
                  />
                : <p className="empty">No solution yet.</p>
    );

    return (
        <>
            <div ref={sidebarRef} className={`fs-sidebar${open ? ' fs-sidebar-open' : ' fs-sidebar-closed'}`}>

                {/* Floating toggle button — overlaid at interior edge, takes no extra width */}
                <button
                    className="fs-toggle-btn"
                    onClick={() => setOpen(o => !o)}
                    title={open ? 'Collapse info panel' : 'Expand info panel'}
                >
                    {open ? '▶' : '◀'}
                </button>

                {/* Panel body */}
                <div className="fs-panel-body">

                    {/* ── Icon toolbar ─────────────────────────────────── */}
                    <div className="fs-icon-toolbar">
                        <button
                            className={`fs-icon-btn${settingsOpen ? ' fs-icon-btn-active' : ''}`}
                            onClick={() => { setSettingsOpen(o => !o); setHelpOpen(false); }}
                            title="Settings"
                        >
                            <GearIcon />
                        </button>
                        <button
                            className={`fs-icon-btn${helpOpen ? ' fs-icon-btn-active' : ''}`}
                            onClick={() => { setHelpOpen(o => !o); setSettingsOpen(false); }}
                            title="Help"
                        >
                            <HelpIcon />
                        </button>
                        <a
                            className="fs-icon-btn"
                            href="https://github.com/yuriykulinchenko/prolog_visualiser"
                            target="_blank"
                            rel="noreferrer"
                            title="GitHub"
                        >
                            <GitHubIcon />
                        </a>
                    </div>

                    {/* ── Help (inline) ────────────────────────────────── */}
                    {helpOpen && (
                        <div className="fs-help-inline">
                            <div className="fs-help-section">
                                <div className="fs-help-heading">Controls</div>
                                <div className="fs-help-row"><kbd>Run</kbd><span>Initialise query, reset to step 0</span></div>
                                <div className="fs-help-row"><kbd>All</kbd><span>Run to completion immediately</span></div>
                                <div className="fs-help-row"><kbd>▶</kbd><span>Play / pause animated stepping</span></div>
                                <div className="fs-help-row"><kbd>⏭</kbd><span>Advance one step</span></div>
                                <div className="fs-help-row"><kbd>scrubber</kbd><span>Jump to any recorded step</span></div>
                            </div>
                            <div className="fs-help-section">
                                <div className="fs-help-heading">Graph</div>
                                <div className="fs-help-row"><span className="fs-help-swatch fs-help-swatch-active"/>  <span>Active frame (current goal)</span></div>
                                <div className="fs-help-row"><span className="fs-help-swatch fs-help-swatch-success"/><span>Solution found</span></div>
                                <div className="fs-help-row"><span className="fs-help-swatch fs-help-swatch-chain"/>  <span>On the active execution path</span></div>
                                <div className="fs-help-row"><span className="fs-help-swatch fs-help-swatch-inactive"/><span>Inactive / backtracked frame</span></div>
                                <div className="fs-help-row"><span className="fs-help-swatch fs-help-swatch-neg"/>   <span>Negation-as-failure goal</span></div>
                            </div>
                        </div>
                    )}

                    {/* ── Settings (inline — panel expands to fit) ──────── */}
                    {settingsOpen && (
                        <div className="fs-settings-inline">
                            <SettingsRow label="Inactive frames">
                                <select
                                    className="settings-select"
                                    value={inactiveFrames}
                                    onChange={e => setInactiveFrames(e.target.value)}
                                >
                                    <option value="show">Show</option>
                                    <option value="dim">Dim</option>
                                    <option value="hide">Hide</option>
                                </select>
                            </SettingsRow>
                            <SettingsRow label="Bindings">
                                <Toggle value={showBindings} onChange={setShowBindings} />
                            </SettingsRow>
                            <SettingsRow label="Decision stack">
                                <Toggle value={showDecisionStack} onChange={setShowDecisionStack} />
                            </SettingsRow>
                            <SettingsRow label="Interpreter errors">
                                <Toggle value={showInternalErrors} onChange={setShowInternalErrors} />
                            </SettingsRow>
                            <SettingsRow label="Tail call optimisation">
                                <Toggle value={tailCallOpt} onChange={setTailCallOpt} />
                            </SettingsRow>
                            <SettingsRow label="Light mode">
                                <Toggle value={lightMode} onChange={setLightMode} />
                            </SettingsRow>
                        </div>
                    )}

                    {/* ── Last Action ──────────────────────────────────── */}
                    <div className="fs-section">
                        <div className="fs-section-title">Last Action</div>
                        {display ? (
                            <>
                                {display.solutionFound && (
                                    <div className="badge badge-solution">Solution found</div>
                                )}
                                {display.solverState === 'DONE' && (
                                    <div className="badge badge-end">No more solutions</div>
                                )}
                                {display.solverState === 'ERROR_STACK' && (
                                    <pre className="clause-error fs-error">{display.error}</pre>
                                )}
                                {display.solverState === 'ERROR_CHOICES' && (
                                    <pre className="clause-error fs-error">{display.error}</pre>
                                )}
                                {display.solverState === 'ERROR_TERM_VECTOR' && (
                                    <pre className="clause-error fs-error">{display.error}</pre>
                                )}
                                {display.solverState === 'DONE' && display.error && !display.errorIsInternal && (
                                    <pre className="clause-error fs-error">{display.error}</pre>
                                )}
                                {display.solverState === 'DONE' && display.error && display.errorIsInternal && showInternalErrors && (
                                    <pre className="clause-error fs-error">{`[internal] ${display.error}`}</pre>
                                )}
                                {display.lastStep
                                    ? <div className="last-action">
                                          <span className="last-action-label">Action</span>
                                          <span className="last-action-value">{display.lastStep}</span>
                                      </div>
                                    : <p className="empty">No action yet.</p>
                                }
                            </>
                        ) : (
                            <p className="empty">No query run yet.</p>
                        )}
                    </div>

                    {/* ── Solutions ────────────────────────────────────── */}
                    <div className="fs-section">
                        <div className="fs-section-title-row">
                            <span className="fs-section-title" style={{ margin: 0 }}>Solutions</span>
                            <div className="fs-section-title-controls">
                                {solutionNav}
                                {solution && (
                                    <button
                                        className="solution-expand-btn"
                                        onClick={() => setSolutionExpanded(true)}
                                        title="Expand"
                                    >↗</button>
                                )}
                            </div>
                        </div>
                        {solutionContent}
                    </div>

                    {/* ── Execution Stack (opt-in) ──────────────────────── */}
                    {showStack && display && (
                        <div className="fs-section">
                            <div className="fs-section-title">
                                Stack
                                <span className="fs-section-count">{display.stack.length}</span>
                            </div>
                            {display.stack.length === 0
                                ? <p className="empty">No frames.</p>
                                : <div className="stack stack-compact">
                                    {[...Array(display.stack.length).keys()].reverse()
                                        .filter(i => inactiveFrames !== 'hide' || activeChain.has(i))
                                        .map(origIdx => {
                                            const frame = display.stack[origIdx];
                                            const isActive = origIdx === display.stackPointer;
                                            const isParentHighlighted =
                                                hoveredIdx !== null &&
                                                display.stack[hoveredIdx]?.parent === origIdx &&
                                                origIdx !== hoveredIdx;
                                            const isInactiveChain =
                                                inactiveFrames === 'dim' && !activeChain.has(origIdx);
                                            return (
                                                <div
                                                    key={origIdx}
                                                    className={[
                                                        'frame',
                                                        isActive            ? 'frame-active' : '',
                                                        isParentHighlighted ? 'frame-parent' : '',
                                                    ].join(' ').trim()}
                                                    style={isInactiveChain ? { opacity: 0.3 } : undefined}
                                                    onMouseEnter={() => setHoveredIdx(origIdx)}
                                                    onMouseLeave={() => setHoveredIdx(null)}
                                                >
                                                    <span className="frame-arrow">{isActive ? '▶' : ''}</span>
                                                    <span className="frame-index">
                                                        {origIdx === display.stack.length - 1 ? 'top' : origIdx}
                                                    </span>
                                                    <div className="frame-content">
                                                        <FrameContent
                                                            frame={frame}
                                                            termVec={display.termVec}
                                                            idVec={idVec}
                                                            varIdVec={varIdVec}
                                                            isActive={isActive}
                                                            showBindings={showBindings}
                                                        />
                                                    </div>
                                                    {choicePointMap.has(origIdx) && (() => {
                                                        const cp = choicePointMap.get(origIdx);
                                                        return (
                                                            <span className={`frame-choice-indicator${cp.type === 'NEGATION' ? ' negation' : ''}`}>
                                                                {cp.type === 'NEGATION' ? '◆' : `◆${cp.decisionIndex}`}
                                                            </span>
                                                        );
                                                    })()}
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            }
                        </div>
                    )}

                    {/* ── Decision Stack (opt-in) ───────────────────────── */}
                    {showDecisionStack && display && (
                        <div className="fs-section">
                            <div className="fs-section-title">
                                Decision Stack
                                <span className="fs-section-count">{display.history.length}</span>
                            </div>
                            {display.history.length === 0
                                ? <p className="empty">No decision points.</p>
                                : <div className="decision-stack">
                                    {[...display.history].reverse().map((dp, i) => {
                                        const historyIdx = display.history.length - 1 - i;
                                        const isHovered  = hoveredDecisionIdx === historyIdx;
                                        const isNeg      = dp.type === 'NEGATION';
                                        return (
                                            <div
                                                key={historyIdx}
                                                className={[
                                                    'decision-point',
                                                    isNeg    ? 'decision-point-negation' : '',
                                                    isHovered ? 'decision-point-hovered'  : '',
                                                ].filter(Boolean).join(' ')}
                                                onMouseEnter={() => setHoveredDecisionIdx(historyIdx)}
                                                onMouseLeave={() => setHoveredDecisionIdx(null)}
                                            >
                                                <span className="decision-index">
                                                    {historyIdx === display.history.length - 1 ? 'top' : historyIdx}
                                                </span>
                                                <span className="decision-type-badge">◆</span>
                                                <span className="decision-value">frame {dp.stackIndex}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            }
                        </div>
                    )}

                </div>
            </div>

            {/* Solution expand overlay */}
            {solutionExpanded && (
                <div className="solution-overlay">
                    <div className="solution-overlay-header">
                        <span className="solution-overlay-title">Solutions</span>
                        <div className="solution-overlay-controls">
                            {count > 0 && (
                                <div className="solution-nav">
                                    <button
                                        className="solution-nav-btn"
                                        onClick={() => onOffsetChange(eff + 1)}
                                        disabled={pos <= 1}
                                        title="Older solution"
                                    >◀</button>
                                    <span className="solution-nav-count">{pos}/{count}</span>
                                    <button
                                        className="solution-nav-btn"
                                        onClick={() => onOffsetChange(eff - 1)}
                                        disabled={pos >= count}
                                        title="Newer solution"
                                    >▶</button>
                                </div>
                            )}
                            <button
                                className="solution-overlay-close"
                                onClick={() => setSolutionExpanded(false)}
                                title="Close"
                            >✕</button>
                        </div>
                    </div>
                    <div className="solution-overlay-body">
                        {solutionContent}
                    </div>
                </div>
            )}
        </>
    );
}
